<ng-content></ng-content>
<table class="table table-borderless definitions w-100">
    <tbody>
        @let timelineValue = timeline();
        @let situationTimelineCount = timelineValue.length ;
        @for (situationTimeline of timelineValue; track situationTimeline.id) {
        @let key = situationTimeline.id;
        <tr>
            @if (situationTimelineCount > 1) {
                <td (click)="isTimeLineExpanded[key] = !isTimeLineExpanded[key]" class="expanding" style="width: 20px;">
                    <ng-icon name="bootstrapChevronDown"  size="16px" [@openClose]="isTimeLineExpanded[key] ? 'open' : 'closed'" class="d-inline-block"></ng-icon>
                </td>
            }
            <td>
                @if (key != highlightSituationID() || linkall()) {
                    <a [routerLink]="'/situations/'+ key" target="_blank" [innerHTML]="createTimeLineEntrySummary($any(situationTimeline.entries))"></a>
                } @else {
                    <span [innerHTML]="createTimeLineEntrySummary($any(situationTimeline.entries))"></span>
                }
            </td>

        </tr>

        @if (isTimeLineExpanded[key] || situationTimelineCount === 1) {
        <tr @expandCollapse [@.disabled]="situationTimelineCount > 1">
            <td colspan="99">
                <div [class.collapsible]="situationTimelineCount > 1">
                    <table class="table table-borderless definitions w-100">
                        <tbody>
                            @for (entry of situationTimeline.entries; track entry) {
                            <tr>
                                <td style="width: 20px;"></td>
                                <td style="width: 120px;">
                                    {{entry.date | date: 'mediumDate'}}
                                </td>
                                @if (entry.reasonID < 1000) {
                                    <td>
                                        {{entry.reason}}
                                    </td>
                                } @else {
                                    <td style="width: 150px;">
                                        {{entry.reason}}
                                    </td>
                                }
                                <td>
                                    @if (entry.newsArticleID > 0) {
                                    <a [routerLink]="'/news/' + entry.newsArticleID" target="_blank" [innerHTML]="entry.headline | safeHtml"></a>
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </td>
        </tr>
        }
        }
    </tbody>
</table>